import React from 'react';
import { Form, FormActionsAlign, FormHandlers } from '@doveit/bricks';
import { AggregatorPromotion } from '../../../domain/types';
import { asSelectOptions } from '../../../select-options/utils/asSelectOptions';
import { aggregatorPromotionLabels } from '../../constants';

export interface PublishedOnPromotionFormModel {
  promotion: AggregatorPromotion | 'NO' | ''
}

export interface PublishedOnPromotionFormProps extends React.AriaAttributes {
  allowedPromotions?: AggregatorPromotion[],
  initialValues?: Partial<PublishedOnPromotionFormModel>,
  disabled?: boolean,
  loading?: boolean,
  innerRef?: React.MutableRefObject<FormHandlers>
  onSubmit: (values: PublishedOnPromotionFormModel) => void,
}

export const PUBLISHED_ON_PROMOTION_FORM_DEFAULT_VALUES: PublishedOnPromotionFormModel = {
  promotion: '',
};

const PublishedOnPromotionForm: React.FC<PublishedOnPromotionFormProps> = ({
  allowedPromotions = [],
  initialValues = {},
  innerRef,
  ...rest
}) => {
  const mergedValues = React.useMemo(() => ({
    ...PUBLISHED_ON_PROMOTION_FORM_DEFAULT_VALUES,
    ...initialValues,
  }), [initialValues]);

  const allowedLabels = React.useMemo(() => Object.fromEntries(
    Object
      .entries(aggregatorPromotionLabels)
      .filter(([key]) => allowedPromotions.includes(key as AggregatorPromotion)),
  ), [allowedPromotions]);

  return (
    <Form
      initialValues={mergedValues}
      innerRef={innerRef}
      {...rest}
    >
      <Form.Item>
        <Form.RadioButtonGroup
          name="promotion"
          label="Seleziona una tipologia o nessuna"
          aria-label="Campo per specificare la tipologia dell'annuncio"
          itemSize={{ MD: 1 / 3, LG: 1 / 4 }}
          items={asSelectOptions({
            NO: 'Nessuna',
            ...allowedLabels,
          }, false)}
        />
      </Form.Item>

      {!innerRef && (
        <Form.Actions align={FormActionsAlign.RIGHT}>
          <Form.Submit label="Salva" />
        </Form.Actions>
      )}
    </Form>
  );
};

export default PublishedOnPromotionForm;
